import React, { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router';
import { getReturnToRedirect } from './helpers';

export function ReturnToLinkHandler({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const redirect = getReturnToRedirect();

    if (redirect) {
      void navigate(redirect, { replace: true });
    }
  }, [navigate]);

  return <>{children}</>;
}
